import { MicrosoftAuthService } from "./authentication.service";
import { UserService } from "./user.service";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class UploadService {
  public identity: any;
  private token: any;

  constructor(
    private _authService: MicrosoftAuthService,
    private http: HttpClient
  ) {
    this.token = _authService.getToken()
  }

  makeFileRequest(url: string, params: any, files: File[], name: string, token?: any) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(name, files[i], files[i].name);
    }
    return firstValueFrom(
      this.http.post(url, formData, {
        headers: {
          'Authorization': this.token,
          'Accept': 'application/json; charset=utf-8'
        }
      })
    ).catch(error => {
      console.warn('Error uploading file:', error);
      throw error;
    });
  }
}